<template>
   <div class="searchInput" v-bind = "{...$attrs}" v-on="$listeners" @click.stop>
		 <div  class="divList" @click="divClick(true)">
				<div ref="pDiv" style="display: inline-block;white-space: nowrap;" v-if="values.length>0">
					<span   v-for="(data,i) in values" :key="i" v-if="i<isFull">{{data.title}}</span>
					<span v-if="values.length>isFull">...</span>
				</div>
				<div style="position: absolute;right: 5px;height: 34px;top: 0;width: 28px;text-align: center;cursor: pointer;" @click="divClick()">
					<i class="el-icon-arrow-down" v-show="!show" ></i>
					<i class="el-icon-arrow-up" v-show="show"></i>
				</div>
				
		 </div>
		 <div class="filterBox" v-show="show">
			 <div class="filter">
			 	<span v-for="(filter,i) in filterArr" :key="i" :class="{'active':i==active}" @click="spanClick(i)">{{filter}}</span>
			 </div>
			 <div class="filterResult">
				  <span v-if="dataList.length>0" v-for="(data,i) in dataList" :key="i" @click="toggleClick(data.title,data,$event)" :class="{'checked':data.active||active==0}">{{data.title}}</span>
			 </div>
		 </div>
	 </div>
      
</template>

<script>
  export default {
    name: "step4",
    props: {
        values: {
					type: Array
        },
				lists:{
					type: Array
				}
    },
    data() {
      return {
         filterStr:'',
				 show:false,
				 active:0,
				 filterArr:[
					 '已选择','ABCDE','FGHIJ','KLMNO','PQLST','UVW','XYZ'
				 ],
				 isFull:4,
				 first:true
      };
    },
		mounted() {
			document.addEventListener('click',()=>{
				this.show = false;
			});
		},
		updated() {
			if(this.first){
				this.first = false;
			if(this.$refs.pDiv){
				let width1 = 0;
				let childNodes = this.$refs.pDiv.childNodes;
				for(var i=0;i<childNodes.length;i++){
					if(childNodes[i].offsetWidth){
						width1= childNodes[i].offsetWidth+width1+10;
						if(width1>330&&this.isFull=='4'){
							this.isFull = i-1;
						}
					}
				}
			}
			}
		},
		computed:{
			dataList(){
				if(this.active==0){
					this.values.map((value)=>{
						value.active = true
					})
					return this.values;
				}else{
					let datas = [];
					let filter = this.filterArr[this.active].toLowerCase();
					this.lists.map((list)=>{
						let zimuArr = list.zimu.toLowerCase().split("");
						list.active = false;
						for (var i = 0; i < zimuArr.length; i++) { 
										if(filter.indexOf(zimuArr[i])>=0){
											this.values.map((value)=>{
												if(value.title==list.title){
													list.active = true;
												}
											})
											datas.push(list);
											return false;
										}
								 }
					});
					return datas;
				}
			}
		},
    methods: {
				spanClick(i){
					this.active = i;
				},
				divClick(boolen){
					if(boolen){
						this.show = true;
					}else{
						this.show = !this.show ;
					}
				},
				Full(w){
					if(this.$refs.pDiv){
						let width1 = this.$refs.pDiv.offsetWidth + w;
						if(width1>330){
							if(this.isFull==4){
								this.isFull = this.values.length-1;
							}
							
						}else{
							this.isFull = 4;
						}
					}
				},
				toggleClick(title,data,event){
					let toggleClick = false;
					for(var i=0;i<this.values.length;i++){
						if(this.values[i].title==title){
							this.values.splice(i,1);
							toggleClick = true;
						}
					};
					if(!toggleClick){
						this.values.push(data);
						this.Full(event.currentTarget.offsetWidth)
					}
				}
    }
  };
</script>

<style scoped >
   .searchInput{
   	min-height: 34px;
   	width:calc(100% - 140px);
   	border-radius:4px;
   border:1px solid rgba(221,221,221,1);
   box-sizing: border-box;
   display: inline-block;
   vertical-align: top;
	 background: #fff;
	 position: relative;
	 z-index: 10;
   }
	 .searchInput.show{
		 z-index: 11;
	 }
	 .searchInput .filterBox{
	 	display: none;
	 }
	 .searchInput.show .filterBox{
		 display: block;
	 }
	 .divList{
		 height: 34px;
	 }
	 .divList span,.filterResult span{
		 display: inline-block;
		 padding: 1px 5px;
		 
		border-radius:2px;
		font-size:12px;
		font-weight:400;
		color:rgba(51,51,51,1);
		line-height:17px;
		margin-left: 10px;
		height: 17px;
	 }
	 .divList span,.filterResult span.checked{
		 background:rgba(241,241,241,1);
	 }
	 .filter{
		 display: flex;
		 justify-content: space-between;
		 height:22px;
		background:rgba(243,243,243,1);
		border-radius:11px;
		margin: 10px 9px 6px;
		padding: 0 16px;
		align-items: center;
	 }
	 .filter span{
		 font-size:10px;
		font-weight:400;
		color:rgba(153,153,153,1);
		line-height: 22px;
		cursor: pointer;
	 }
	 .filter span.active{
		 color:rgba(51,51,51,1);
	 }
	 .filterResult{
		 margin: 0 11px;
	 }
	.filterResult span{
		cursor: pointer;
	}
</style>
